import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitleConfigure: {
    defaultMessage: 'Configure & Submit Request',
    description: 'Title for modal used to configure a return request',
    id: 'J4LNEF',
  },
  modalTitleCreate: {
    defaultMessage: 'Create Return',
    description: 'Title for modal used to create a return',
    id: 'bnjMgD',
  },
  closeDrawerButtonAriaLabel: {
    defaultMessage: 'Close New Return Drawer',
    description: 'Label for button that closes new return drawer',
    id: 'JQBILg',
  },
});
